import React from 'react';
import './MasteryBrainIcon.css';

/** Snippet mastery stat — open barbell outline (gym metaphor; matches header line icons). */
export default function MasteryBrainIcon({ className }) {
  return (
    <svg
      className={['mastery-stat-icon', 'mastery-bicep-icon', className].filter(Boolean).join(' ')}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <line
        className="mastery-stat-icon__bar"
        x1="7.25"
        y1="12"
        x2="16.75"
        y2="12"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <rect
        className="mastery-stat-icon__plate"
        x="3"
        y="8.25"
        width="3.25"
        height="7.5"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <rect
        className="mastery-stat-icon__plate"
        x="17.75"
        y="8.25"
        width="3.25"
        height="7.5"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.75"
      />
    </svg>
  );
}
